/* ============================================================
   CIY Crafts — Product Detail Page Figma restyle
   ------------------------------------------------------------
   Two DOM relocations that CSS cannot express, because the elements
   live in different block containers than the Figma puts them in:

     1. `.product-action-icons` (wishlist + share) moves from the
        buy-buttons row up into the title row.
     2. `.ciy-off` (the "N% OFF" badge) moves inline into <product-price>.

   Both are defensive: if an element is missing, nothing happens and the
   page keeps the theme's own layout. Nothing here changes cart, variant,
   or pincode behaviour.
   ============================================================ */
(function () {
  'use strict';

  function enhance(root) {
    var scope = root || document;

    var details = scope.querySelector('.product-details');
    if (!details) return;

    /* ---- 1. Title row: pull the wishlist/share icons up beside the <h1> ---- */
    var h1 = details.querySelector('h1');
    var icons = details.querySelector('.product-action-icons');

    if (h1 && icons && !h1.closest('.ciy-title-row')) {
      var titleHost = h1.parentElement;
      var row = document.createElement('div');
      row.className = 'ciy-title-row';
      titleHost.insertBefore(row, h1);
      row.appendChild(h1);
      row.appendChild(icons);
    }

    /* ---- 2. Discount badge: move it inline into the price ---- */
    var badge = details.querySelector('.ciy-off');
    var price = details.querySelector('product-price');

    if (badge && price && !price.contains(badge)) {
      var target = price.querySelector('.price') || price;
      target.appendChild(badge);
      badge.removeAttribute('hidden');
    }

    /* ---- 3. Wishlist/share glyphs: swap in the Figma's pair ----
       The theme ships its own icons (a dot-and-lines share mark); node
       175:17266 uses an outline heart and an export box-with-arrow. Only the
       <svg> inside each button is replaced, so the theme's own click handlers,
       classes and aria labels are left completely alone. */
    swapIcon(details.querySelector('.product-page-wishlist-btn'), 'data-ciy-heart',
      '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z"/>');

    swapIcon(details.querySelector('.product-page-share-btn'), 'data-ciy-share',
      '<path d="M12 15V3"/><path d="M8 7l4-4 4 4"/><path d="M4 14v4.5A2.5 2.5 0 0 0 6.5 21h11a2.5 2.5 0 0 0 2.5-2.5V14"/>');
  }

  /* `flag` goes through setAttribute, not dataset: a DOMStringMap key
     containing a dash throws, which killed the function after the first icon
     and left the share button on the theme's glyph. */
  function swapIcon(btn, flag, paths) {
    if (!btn || btn.getAttribute(flag) === '1') return;
    var svg = btn.querySelector('svg');
    if (!svg) return;
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.7');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.innerHTML = paths;
    btn.setAttribute(flag, '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhance(); });
  } else {
    enhance();
  }

  /* The theme re-renders the details column on variant change, which throws
     away our relocations. Re-run after any section re-render. */
  document.addEventListener('variant:update', function () { enhance(); });
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });
})();
